import React, {Component} from "react";
import Web3 from "web3";
import axios from "axios";
// import "./App.css";
import {TODO_LIST_ABI, TODO_LIST_ADDRESS} from "./config";
import TodoList from "./titleList";
import _ from "lodash";
class App extends Component {
  componentWillMount() {
    this.loadBlockchainData();
  }
  state = {tasks: []};

  async loadBlockchainData() {
    const web3 = new Web3(Web3.givenProvider || "http://localhost:8545");
    const accounts = await web3.eth.getAccounts();

    this.setState({account: accounts[0]});
    const todoList = new web3.eth.Contract(TODO_LIST_ABI, TODO_LIST_ADDRESS);
    this.setState({todoList});
    const taskCount = await todoList.methods.taskCount().call();
    this.setState({taskCount});
    for (var i = 1; i <= taskCount; i++) {
      const task = await todoList.methods.tasks(i).call();
      task.mainAuthor = JSON.parse(task.authors)[0].fullname;

      this.setState({
        tasks: [...this.state.tasks, task],
      });
    }
    this.setState({loading: false});

    console.log(this.state.account);
  }

  constructor(props) {
    super(props);
    this.state = {
      account: "",
      taskCount: 0,
      tasks: [],
      loading: true,
      user: window.localStorage.getItem("user", null),
    };

    this.createTask = this.createTask.bind(this);
    this.toggleCompleted = this.toggleCompleted.bind(this);
  }

  createTask(title, category, contents, authors) {
    this.setState({loading: true});

    let date = new Date().toString();
    this.state.todoList.methods
      .createTask(title, category, contents, authors, date)
      .send({from: this.state.account})
      .once("receipt", (receipt) => {
        //let tsk = receipt.events.TaskCreated.returnValues;
        // console.log(receipt.events.TaskCreated.returnValues);

        this.setState(
          {
            loading: false,
            // tasks: [
            //   ...this.state.tasks,
            //   {id: tsk.id, content: tsk.content, completed: tsk.completed},
            // ],
          },
          () => {
            window.location.reload();
          }
        );
      });
  }

  toggleCompleted(taskId) {
    this.setState({loading: true});
    this.state.todoList.methods
      .toggleCompleted(taskId)
      .send({from: this.state.account})
      .once("receipt", (receipt) => {
        let tsk = receipt.events.TaskCompleted.returnValues;
        console.log(receipt);
        window.location.reload();
        this.state.tasks[taskId].completed = tsk.completed;
        this.setState({
          loading: false,
          tasks: this.state.tasks,
        });
      });
  }
  componentDidMount() {
    console.log("sddssddsd");
  }

  render() {
    return (
      <div>
        <div>
          <main
            className="page-wrapper"
            style={{maxHeight: 100, minHeight: 40}}>
            <div
              className="rn-slider-area position-relative"
              id="home"
              style={{marginTop: -0}}>
              <div id="particles-js"></div>
              <div
                className="slide slide-style-2 bg_image bg_image--27 d-flex align-items-center justify-content-center"
                style={{}}></div>
            </div>
          </main>

          <div className="container-fluid" style={{marginTop: 0}}>
            <div className="row">
              <main
                role="main"
                className="col-lg-12 d-flex justify-content-center">
                {this.state.loading ? (
                  <div id="loader" className="text-center">
                    <p className="text-center">Loading...</p>
                  </div>
                ) : (
                  <TodoList
                    tasks={this.state.tasks}
                    createTask={this.createTask}
                    toggleCompleted={this.toggleCompleted}
                  />
                )}
              </main>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default App;
